import type { Service } from './schema'
import { tools } from './tools'

export const servicesPage = {
  eyebrow: 'Services',
  title: 'Automation, CRM, funnels, sites and AI agents.',
  lede: 'What I build, what it does for you, and what it runs on. Pick one or stack a few.',
}

/**
 * The Home Services section: a sideways rail of cards (Kenneth 2026-10-02; it replaced the "A Stack"
 * pick). The display line is the page lede.
 */
export const servicesSection = {
  eyebrow: servicesPage.eyebrow,
  titleThin: 'Pick one',
  titleBold: 'or stack a few.',
  explore: 'Explore',
  /** The Work chapter each card opens. [CONFIRM] CRM Setup -> the ticketing system (a GHL pipeline build). */
  work: { automation: 'automations', crm: 'ticketing', funnels: 'websites', websites: 'websites', apps: 'apps' } as Record<string, string>,
}

export const services: Service[] = [
  {
    id: 'automation',
    title: 'GHL Automation',
    summary: 'Follow-up that runs on its own.',
    outcome: 'Runs 24/7',
    bullets: ['Messages send themselves', 'Leads move on their own', 'AI does the busywork'],
    tools: [tools.ghl, tools.n8n, tools.openai],
  },
  {
    id: 'crm',
    title: 'CRM Setup',
    summary: 'A CRM your team will actually use.',
    outcome: 'Easy to use',
    bullets: ['Every contact easy to find', 'A pipeline that fits how you sell', 'New clients set up without you'],
    tools: [tools.ghl, tools.workspace, tools.slack],
  },
  {
    id: 'funnels',
    title: 'AI-assisted Funnels',
    summary: 'Pages that turn visitors into leads.',
    outcome: 'Built to convert',
    bullets: ['Fast pages people finish', 'Checkout that just works', 'Lives in GHL or on its own'],
    tools: [tools.ghl, tools.react, tools.tailwind],
  },
  {
    id: 'websites',
    title: 'Websites',
    summary: 'Fast, custom, and yours to keep.',
    outcome: 'You own the code',
    bullets: ['Loads fast on every device', 'Connects to your GHL', 'Code you can take anywhere'],
    tools: [tools.react, tools.vite, tools.cloudflare],
  },
  {
    id: 'apps',
    title: 'Apps',
    summary: 'Small tools that fix real problems.',
    outcome: 'Ships in days',
    bullets: ['Web, mobile and Chrome apps', 'AI built in from day one', 'Scoped small so it ships fast'],
    tools: [tools.claudeCode, tools.expo, tools.chrome],
  },
]
